import { gql } from '@apollo/client';
import useMutation from 'api/hooks/useMutation';
import permissions from 'api/Apollo/permissions';

import { ORG_PRIMARY_CLUSTER_QUERY } from './useQueryOrgPrimaryCluster';

export const mutation = gql`
  mutation UpdateOrgPrimaryCluster($orgId: String!, $primaryClusterId: uuid) {
    org: update_orgs_by_pk(pk_columns: { id: $orgId }, _set: { primaryClusterId: $primaryClusterId }) {
      id
      primaryClusterId
    }
  }
`;

export default function useUpdateOrgPrimaryCluster(options = {}) {
  const [executeMutation, response] = useMutation(mutation, {
    successMsg: 'Primary cluster updated.',
    context: { permission: permissions.createSecret },
    refetchQueries: [ORG_PRIMARY_CLUSTER_QUERY],
    ...options,
  });

  const updatePrimaryCluster = ({ orgId, primaryClusterId }) => {
    return executeMutation({
      variables: { orgId, primaryClusterId },
    });
  };

  return [updatePrimaryCluster, response];
}
